import React, {Component, PropTypes} from 'react';

import BasicLayout from 'layouts/Basic';

import DataGrid from 'components/vacancies/DataGrid.jsx';
import Indepth from 'components/vacancies/Indepth.jsx';
import Controls from 'components/vacancies/Controls.jsx';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {selected: []};
  }
  select = (selected) => {
    this.setState({selected: Object.keys(selected)});
  }
  render() {
    const props = this.props;
    return (
      <BasicLayout
        hero={props.selected && <Indepth {...props} />}
        main={<DataGrid {...props} select={this.select} />}
        aside={<Controls {...props} selected={this.state.selected} />}
      />
    );
  }
};

import {resource} from 'utils/resourcerizer';
import {connect} from 'react-redux';
import {updateMatchesWith} from 'actions';
import {VACANCIES_NS} from 'constants/index';

const mstp = state => ({
  isMatching: state.matches.isMatching,
});

const mdtp = dispatch => ({
  updateMatches: (vacancies) => dispatch(updateMatchesWith({vacancyIds: vacancies})),
});

Page.Container = resource(VACANCIES_NS)(connect(mstp,mdtp)(Page));
export default Page;



// WEBPACK FOOTER //
// ./src/components/vacancies/Page.jsx